import React, { useContext } from "react";
import { bigProjects } from "../../portfolio";
import { motion } from "framer-motion";
import StyleContext from "../../contexts/StyleContext";
import Slider from "react-slick";
import "./StartupProjects.scss";
import Divex from '../Divex.tsx'

export default function StartupProject() {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const { isDark } = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  return (
    <div
      className={`${isDark ? "dark-mode main" : "main"} content-rail`}
      id="projects"
    >
    <motion.div
      initial={{ opacity: 0, y: 200 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >
      <div className="main" id="projects" >
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              const showTrailer = project.showTrailer ?? Boolean(project.videoUrl);
              const wrapperClass = `project-wrapper ${showTrailer ? "" : "project-wrapper--single"}`;

              return (
                <>

                <div key={i} className={wrapperClass}>
                  {/* Project Card */}

                  <div
                    className={
                      isDark
                        ? "dark-mode project-card project-card-dark"
                        : "project-card project-card-light"}>

                    {project.image && (
                      <div
                        className="project-image"
                        style={{ padding: "15px", display: "flex", flexDirection: "column" }}
                      >
                        <h5
                          className={isDark ? "dark-mode card-title-project" : "card-title-project"}
                        >
                          {project.projectName}
                        </h5>

                        {project.image.endsWith(".mp4") ? (
                          <video
                            src={project.image}
                            className="card-imageproject"
                            autoPlay
                            loop
                            muted
                            playsInline
                          />
                        ) : (
                          <img
                            src={project.image}
                            alt={project.projectName}
                            className="card-imageproject"
                          />
                        )}
                      </div>
                    )}

                    <div className="project-detail">

                      <p
                        className={isDark ? "dark-mode card-subtitle-project" : "card-subtitle-project"} >
                        {project.projectDesc}
                      </p>
                      {project.footerLink && (
                        <div className="project-card-footer">
                          {project.footerLink.map((link, idx) => (
                            <span
                              key={idx}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={() => openUrlInNewTab(link.url)}
                            >
                              {link.name}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {showTrailer && project.videoUrl && (
                    <div className={"project-video-main"}>
                      <header className={"gameplay-text-div"}>Gameplay Trailer</header>
                      <div className={"project-video-inner"}>
                        <iframe
                          src={project.videoUrl}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        />
                      </div>
                    </div>
                  )}


                </div>
                  <h1 className="features-heading"
                      >{"Project Features"}</h1>
                  <Divex features={project.features} />
                </>
              );
            })}
          </div>
        </div>
      </div>
    </motion.div>
  </div>
  );
}
